export default __webpack_public_path__ + "static/media/Tous les articles.b08e21a1.jpg";